export const ALL_CLOSED_WON_VALUE = '__hs__CLOSEDWON';